import { Dispatch, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { AuthType } from '../../../lib/enums';
import { useAuth } from '../../../lib/providers/authProvider';
import { useAuthType } from '../../../lib/providers/authTypeState';
import Image from "next/legacy/image";

interface StepFourProps {
  onSeeResults: () => void;
  setPotentialFilters: Dispatch<any>;
}

const StepFour: React.FC<StepFourProps> = ({
  onSeeResults,
  setPotentialFilters,
}) => {
  const { seeker } = useAuth();
  const { getValues } = useFormContext();
  const { setAuthType } = useAuthType();
  const values = getValues();
  const [styleSentence, setStyleSentence] = useState('');
  const [importantSentence, setImportantSentence] = useState('');
  const [lengthSentence, setLengthSentence] = useState('');

  useEffect(() => {
    const { important, style, type } = getValues();
    const params = {} as any;
    if (important) {
      params.sortBy = important;
    } else {
      delete params.sortBy;
    }
    if (style) {
      params.style = style.join('_');
    } else {
      delete params.style;
    }
    if (type) {
      params.length = type;
    } else {
      delete params.length;
    }
    setPotentialFilters(params);
  }, []);

  useEffect(() => {
    const { important, type, style } = values;
    const last = [...style].pop();

    const result =
      style.length > 1
        ? [...style.slice(0, -1)].join(', ') + ' and ' + last
        : last;
    setStyleSentence(result);

    let importantResult = '';
    if (important == 'brightOutlook') {
      importantResult = 'a bright outlook';
    } else if (important == 'fastest') {
      importantResult = 'fast training';
    } else if (important == 'salary') {
      importantResult = 'high wages';
    }
    setImportantSentence(importantResult);

    setLengthSentence(type.toLowerCase());
  }, [values]);

  const handleCreateAccountClick = () => {
    setAuthType(AuthType.Register);
  };

  return (
    <>
      <Image
        src="/images/career-quiz-step-4.svg"
        blurDataURL="/images/career-quiz-step-4.svg"
        layout="responsive"
        loading="eager"
        placeholder="blur"
        width={2500}
        height={2000}
        alt="Icon of a person sitting at a computer"
        className="block w-40 mx-auto mt-6 mb-6 md:mb-16 md:mt-0 md:self-end md:w-44"
      />
      <div className="p-8">
        {!seeker ? (
          <>
            <h1 className="text-3xl font-semibold text-center text-careerPageHeading md:text-left">
              Create a profile to save your responses and customize your
              experience!
            </h1>
          </>
        ) : (
          <h2 className="text-3xl font-semibold text-center text-careerPageHeading md:text-left">
            Hi, {seeker.firstName || 'there'}!
          </h2>
        )}
        <div className="w-full my-4 border-b-2 border-dashed border-darkGray"></div>

        <p className="text-3xl text-careerPageHeading font-semibold my-4 leading-[50px] pr-8 text-center md:text-left">
          <span className="italic font-bold border-b-2 border-dashed text-careerPageHighlight border-careerPageHighlight">
            {styleSentence}
          </span>{' '}
          careers with{' '}
          <span className="italic font-bold border-b-2 border-dashed text-careerPageHighlight border-careerPageHighlight">
            {importantSentence}
          </span>{' '}
          that take{' '}
          <span className="italic font-bold border-b-2 border-dashed text-careerPageHighlight border-careerPageHighlight">
            {lengthSentence}
          </span>{' '}
          to complete are waiting for you!
        </p>

        {!seeker ? (
          <button
            onClick={handleCreateAccountClick}
            className="block w-auto mx-auto my-6 font-medium text-white border-2 border-solid rounded-gnoIncButton bg-careerPageHighlight hover:bg-white hover:text-careerPageHighlight border-careerPageHighlight min-w-gnoIncButton h-gnoIncButton font-heading"
          >
            Create an Account
          </button>
        ) : (
          <button
            onClick={onSeeResults}
            className="block w-auto mx-auto my-6 font-medium text-white border-2 border-solid rounded-gnoIncButton bg-careerPageHighlight hover:bg-white hover:text-careerPageHighlight border-careerPageHighlight min-w-gnoIncButton h-gnoIncButton font-heading"
          >
            See Results{' '}
          </button>
        )}
      </div>
    </>
  );
};

export default StepFour;
